<template>
  <div class="notifications-wrapper">
    <template v-for="(rec, index) in notifications">
      <TransactionNotification
        v-if="rec.show"
        :key="rec.hash"
        :rec="rec"
        @close="close(index)"
        @update-list="updateListHandler"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { flagAsSeenHistoryHash, getHashHistory } from '~/utils';
import type { HashRecord } from '~/utils';
import { useWeb3ModalAccount } from '@web3modal/ethers/vue';
import { SUCCEEDED_TRANSACTION_LIFETIME } from '~/utils/constants';

const notifications = ref<HashRecord[]>([]);
const { isConnected, address } = useWeb3ModalAccount();

onMounted(() => {
  notifications.value = getHashHistory();
});

const updateListHandler = () => {
  console.log(getHashHistory());

  setTimeout(() => {
    notifications.value = getHashHistory();
  }, SUCCEEDED_TRANSACTION_LIFETIME);
};

watch(isConnected, () => {
  if (!isConnected.value) notifications.value = [];
});

watch(address, () => {
  notifications.value = [];
});

function close(index: number) {
  flagAsSeenHistoryHash(notifications.value[index].hash);
  notifications.value = notifications.value.filter((_: HashRecord, i: number) => i !== index);
}
</script>

<style scoped>
.notifications-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: fixed;
  margin: 20px;
  bottom: 20px;
  right: 0;
  z-index: 9999;
  max-height: 520px;
  overflow: hidden;
  pointer-events: none;
}

@media screen and (max-width: 479px) {
  .notifications-wrapper {
    margin: 8px;
    width: calc(100% - 16px);
  }
}
</style>
